module.exports = __webpack_public_path__ + "static/media/more-vertical.57b1259d.svg";